<template>
    <div class="service-carry">
        <mt-header fixed title="编辑服务记录">
            <router-link to="/my/service" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">
            <mt-field label="服务执行简述" placeholder="请输入服务执行简述" rows="6" type="textarea" v-model="desc"></mt-field>

            <div class="mint-checklist">
                <label class="mint-checklist-title">当前服务图片</label>
                <div class="thumbnails my-service-gallery" v-if="thumb.length>0">
                    <figure itemprop="associatedMedia" itemscope="itemscope" class="thumbnail" v-for ="item in thumb">
                        <a itemprop="contentUrl" data-size="400x400" class="img-wrapper" :href="imgUrl+'uploads/'+item">
                            <img itemprop="thumbnail" :src="imgUrl+'uploads/'+item" />
                        </a>
                    </figure>
                </div>
            </div>

            <div class="mint-checklist">
                <label class="mint-checklist-title">重新上传服务图片</label>
                <uploader @getFiles='getImageList' @removeFiles='removeImage'></uploader>
            </div>



            <div class="new-form-button">
                <mt-button size="large" type="primary" @click="updateService()">提交</mt-button>
            </div>
        </div>
    </div>
</template>
<script>

    import PhotoSwipe from "photoswipe";
    import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
    import "photoswipe/dist/photoswipe.css";
    import "photoswipe/dist/default-skin/default-skin.css";
    import uploader from "../../components/upload"
    import GlOBAL from "@/api/global"

    export default{

        components: {
            uploader
        },
        data(){
            return {

                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                service_id:this.$route.params.id,

                desc:'',
                thumb:[],

                imgUrl:GlOBAL.imgUrl,
                imgList: [], //已上传的图片集合
            }
        },

        created(){
            this.$axios.get('/my/serviceEdit?openid='+this.openid+'&service_id='+this.service_id)
                .then(data => {

                    if (data.data.code === 'OK') {
                        this.desc = data.data.data.desc;
                        this.thumb = data.data.data.thumb;
                    } else {
                        this.$toast(data.data.message);
                    }
                });
        },

        methods:{

            getImageList(files) {
                this.$nextTick(() => {
                    for (let i = 0, len = files.length; i < len; i++) {
                        this.imgList.push(files[i].src.split("base64,")[1]);
                        //上传图片
                        //   this._getFileCode({
                        //     Base64Str: files[i].src.split("base64,")[1],
                        //     AttachmentType: this.$enums.AttachmentType.Activity
                        //   });
                    }
                });
            },
            //删除图片
            removeImage(index) {
                this.imgList.splice(index, 1);
            },

            //上传图片获取fileCode (目前该方法没调用，供参考)
            _getFileCode(obj) {
                // Indicator.open(this.lang.dynamic_publishing);
                this.$http
                    .post(this.$profileApi.Shared_UploadImage, obj)
                    .then(data => {
                        if (data.Rstatus) {
                            this.FilecodeList.push(data.Rdata);
                        } else {
                            // Toast(this.lang.dynamic_upload_fail);
                        }
                    })
                    .catch(err => {
                        //   Toast(this.lang.dynamic.dynamic_net_error);
                    });
            },

            updateService(){
                let that = this;

                this.$indicator.open('加载中');

                this.$axios.post("/my/serviceEdit", {openid:this.openid,thumb:this.imgList,service_id:this.service_id,desc:this.desc})
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {
                            this.$toast('服务记录保存成功！');
                            setTimeout(function(){
                           //     that.$router.push('/my/service');
                            },2000);
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            },

            //引入photoSwipe(可预览、滑动)
            initPhotoSwipeFromDOM(gallerySelector) {
                var parseThumbnailElements = function(el) {
                    var thumbElements = el.childNodes,
                        numNodes = thumbElements.length,
                        items = [],
                        figureEl,
                        linkEl,
                        size,
                        item
                    for (var i = 0; i < numNodes; i++) {
                        figureEl = thumbElements[i];
                        if (figureEl.nodeType !== 1) {
                            continue
                        }
                        linkEl = figureEl.children[0];
                        size = linkEl.getAttribute('data-size').split('x')
                        item = {
                            src: linkEl.getAttribute('href'),
                            w: parseInt(size[0], 10),
                            h: parseInt(size[1], 10)
                        };
                        if (figureEl.children.length > 1) {
                            item.title = figureEl.children[1].innerHTML
                        }
                        if (linkEl.children.length > 0) {
                            item.msrc = linkEl.children[0].getAttribute('src')
                        }
                        item.el = figureEl
                        items.push(item)
                    }
                    return items
                }
                var closest = function closest(el, fn) {
                    return el && (fn(el) ? el : closest(el.parentNode, fn))
                }
                var onThumbnailsClick = function(e) {
                    e = e || window.event
                    e.preventDefault ? e.preventDefault() : e.returnValue = false
                    var eTarget = e.target || e.srcElement
                    var clickedListItem = closest(eTarget, function(el) {
                        return (el.tagName && el.tagName.toUpperCase() === 'FIGURE')
                    });

                    if (!clickedListItem) {
                        return;
                    }
                    var clickedGallery = clickedListItem.parentNode,
                        childNodes = clickedListItem.parentNode.childNodes,
                        numChildNodes = childNodes.length,
                        nodeIndex = 0,
                        index
                    for (var i = 0; i < numChildNodes; i++) {
                        if (childNodes[i].nodeType !== 1) {
                            continue
                        }
                        if (childNodes[i] === clickedListItem) {
                            index = nodeIndex
                            break
                        }
                        nodeIndex++
                    }

                    if (index >= 0) {
                        openPhotoSwipe(index, clickedGallery)
                    }
                    return false;
                }
                var photoswipeParseHash = function() {
                    var hash = window.location.hash.substring(1),
                        params = {}
                    if (hash.length < 5) {
                        return params;
                    }
                    var vars = hash.split('&');
                    for (var i = 0; i < vars.length; i++) {
                        if (!vars[i]) {
                            continue
                        }
                        var pair = vars[i].split('=');
                        if (pair.length < 2) {
                            continue
                        }
                        params[pair[0]] = pair[1];
                    }
                    if (params.gid) {
                        params.gid = parseInt(params.gid, 10)
                    }
                    return params
                }

                var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
                    var pswpElement = document.querySelectorAll('.pswp')[0],
                        gallery,
                        options,
                        items
                    items = parseThumbnailElements(galleryElement);
                    options = {
                        history: false,
                        galleryUID: galleryElement.getAttribute('data-pswp-uid'),
                        getThumbBoundsFn: function(index) {
                            var thumbnail = items[index].el.getElementsByTagName('img')[0],
                                pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                                rect = thumbnail.getBoundingClientRect()
                            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
                        }

                    }
                    if (fromURL) {
                        if (options.galleryPIDs) {
                            for (var j = 0; j < items.length; j++) {
                                if (items[j].pid == index) {
                                    options.index = j
                                    break
                                }
                            }
                        } else {
                            options.index = parseInt(index, 10) - 1
                        }
                    } else {
                        options.index = parseInt(index, 10)
                    }
                    if (isNaN(options.index)) {
                        return ''
                    }
                    if (disableAnimation) {
                        options.showAnimationDuration = 0
                    }

                    gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)
                    gallery.init()
                }
                var galleryElements = document.querySelectorAll(gallerySelector)
                for (var i = 0, l = galleryElements.length; i < l; i++) {
                    galleryElements[i].setAttribute('data-pswp-uid', i + 1)
                    galleryElements[i].onclick = onThumbnailsClick
                }
                var hashData = photoswipeParseHash()
                if (hashData.pid && hashData.gid) {
                    openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true)
                }
            }
        },

        updated() {
            this.initPhotoSwipeFromDOM(".my-service-gallery");
        }
    }
</script>
<style scoped>
    .service-order-block{
        background:#fff;
    }

    .service-order-header{
        padding:10px 20px;
        border-bottom:1px solid #f4f4f4;
        font-size:12px;
        color:#848a8f;
        display:flex;
        justify-content: space-between;
    }

    .service-block-body{
        padding:20px;
    }


    .service-tips span{
        font-size:12px;
    }

    .thumbnails {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-flex-wrap: wrap;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        padding: 0 10px;
    }
    .thumbnails .thumbnail {
        position: relative;
        margin: 0 0 10px 0;
        padding-right: 5px;
        flex:1;
        box-sizing: border-box;
        max-width: 70px;
    }
    @media screen and (min-width: 768px) and (max-width: 1024px) {
        .thumbnails .thumbnail {
        }
    }
    .thumbnails .thumbnail .img-wrapper {
        position: relative;
        display: flex;
    }
    @media screen and (min-width: 768px) and (max-width: 1024px) {
        .thumbnails .thumbnail .img-wrapper {
        }
    }
    .thumbnails .thumbnail .img-wrapper img {
        width: 100%;
        max-width: 100%;
        height:50px;
    }



    .service-order{
        display:flex;
    }

    .service-order-thumb img{
        width: 50px;
        height: 50px;
        padding: 5px;
        border: 1px solid #dedede;
    }

    .service-order-info{
        padding-left:15px;
    }

    .service-order-info .service-order-title{
        font-size:14px;
        padding: 4px 0;
    }

    .service-order-info .service-order-tip{
        font-size:12px;
        color: #848a8f;
    }

    .service-order-address{
        font-size:12px;
        color: #848a8f;
        padding-top:10px;
    }


    .elder-form-input{
        margin-top:10px;
    }

    .service-order-title span{
        color:#ffcb01;
        padding-left:5px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/my/serviceEdit.vue